import lodash from "lodash";
import { DeviceModel } from "models";
import { fetcher } from "utils/net";

import useSWR from "swr";
import { useAuth } from "providers/auth";
import { useEffect, useState } from "react";
import { UseDevicesProps } from "./types";

export function useDevices(props?: UseDevicesProps) {
  const limit = lodash(props).get("limit", 5);
  const offset = lodash(props).get("offset", 0);

  const [devices, setDevices] = useState<DeviceModel[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [itemPerPage, setItemPerPage] = useState<number>(0);

  const { accessToken } = useAuth();
  const { data, error, isLoading, mutate } = useSWR(() => {
    if (!accessToken) return undefined;

    return [`/devices?limit=${limit}&offset=${offset}`, accessToken];
  }, fetcher);

  useEffect(() => {
    if (!data) return;

    const ds = data.data.map((d: any) => DeviceModel.fromResponse(d));
    setDevices(ds);

    // We need to set the totalCount
    // And itemPerPage based on the data.pagination.totalCount and data.pagination.limit
    if (!data.pagination) return;
    setTotalCount(data.pagination.total_count);
    setItemPerPage(data.pagination.limit);
  }, [data]);

  return {
    devices: devices,
    isLoading: isLoading,
    error: error,
    totalCount: totalCount,
    itemPerPage: itemPerPage,
    mutate: mutate,
  };
}
